import { useState } from "react";
import Shell from "../components/Shell";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Target } from "lucide-react";

export default function Goals() {
  const { user, updateUser } = useAuth();
  const [form, setForm] = useState({
    income_goal: user?.income_goal || 0,
    avg_commission_per_sale: user?.avg_commission_per_sale || 500,
    cost_per_lead: user?.cost_per_lead || 10,
  });
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.patch("/auth/goals", {
        income_goal: Number(form.income_goal),
        avg_commission_per_sale: Number(form.avg_commission_per_sale),
        cost_per_lead: Number(form.cost_per_lead),
      });
      updateUser(data);
      toast.success("Goals updated");
    } catch { toast.error("Failed to save"); }
    finally { setSaving(false); }
  };

  const salesNeeded = form.income_goal && form.avg_commission_per_sale ? Math.ceil(form.income_goal / form.avg_commission_per_sale) : 0;

  return (
    <Shell>
      <div className="p-4 sm:p-8 max-w-3xl" data-testid="goals-page">
        <div className="label-xs text-amber flex items-center gap-2"><Target size={12} /> KPI_ENGINE</div>
        <h1 className="font-display text-3xl sm:text-5xl leading-none mt-2">Your numbers.</h1>
        <p className="mt-2 text-fg-muted font-mono text-sm">Set targets. Dashboard calculates the rest.</p>

        <form onSubmit={save} className="mt-8 space-y-6 border border-term p-6 bg-raised">
          <div>
            <label className="label-xs mb-2 block">ANNUAL INCOME GOAL ($)</label>
            <input type="number" className="input-term text-2xl font-display text-amber" value={form.income_goal} onChange={(e) => setForm({ ...form, income_goal: e.target.value })} data-testid="goals-income-input" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="label-xs mb-2 block">AVG COMMISSION / SALE ($)</label>
              <input type="number" className="input-term text-lg" value={form.avg_commission_per_sale} onChange={(e) => setForm({ ...form, avg_commission_per_sale: e.target.value })} data-testid="goals-commission-input" />
            </div>
            <div>
              <label className="label-xs mb-2 block">COST / LEAD ($)</label>
              <input type="number" className="input-term text-lg" value={form.cost_per_lead} onChange={(e) => setForm({ ...form, cost_per_lead: e.target.value })} data-testid="goals-cpl-input" />
            </div>
          </div>

          <div className="border-t border-term pt-5">
            <div className="label-xs text-amber">// THE_MATH</div>
            <div className="font-display text-3xl mt-2">
              <span className="text-amber">{salesNeeded}</span> <span className="text-fg-muted text-xl">SALES NEEDED</span>
            </div>
            <div className="text-xs text-fg-muted mt-1 font-mono uppercase tracking-widest">
              ${Number(form.income_goal).toLocaleString()} ÷ ${form.avg_commission_per_sale}/SALE
            </div>
          </div>

          <button type="submit" disabled={saving} className="btn-primary w-full" data-testid="goals-save-btn">
            {saving ? "Saving..." : "Save Goals >"}
          </button>
        </form>
      </div>
    </Shell>
  );
}
